import { getGlobalLookup } from "../deprecated/lookup";

import { getWindow } from "./getWindow";

// Route through getGlobalLookup so that SSR request-scoped lookups
// (see @faire/next-utils/initializers/clientComponentSSR) are honored.
export const getDocument = (): Document | undefined =>
  getGlobalLookup()<Document>("document") ?? getWindow()?.["document"];

export const getDocumentOrThrow = (): Document => {
  const document = getDocument();
  if (!document) {
    throw new Error("document not found");
  }
  return document;
};
